import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, Field } from 'redux-form'
import { Button, Row, Col } from 'react-bootstrap'
import * as actions from '../../../actions'
import { FORM_EGRESO } from '../../../../../config/forms'
import { renderTextField } from '../../../../Forms/fieldRenderers'
import {
  required,
  getNumericValidator
} from '../../../../Forms/fieldValidators'

const numeric12 = getNumericValidator(9, 12)
class Egreso0 extends Component {
  render () {
    const {
      handleSubmit,
      invalid
    } = this.props

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <Row className='justify-content-md-center'>
            <Col md={12}>
              <Field
                className='cpa-grande'
                name='numero'
                type='text'
                label='Número de CTGE'
                component={renderTextField}
                autoFocus
                validate={[required, numeric12]}
                placeholder='10200111222'
              />
            </Col>
          </Row>
          <br />
          <Button
            type='submit'
            disabled={invalid}
            size='lg'
          >Aceptar</Button>
        </form>
      </div>
    )
  };
};

const mapStateToProps = (state) => ({
  invalid: isInvalid(FORM_EGRESO)(state)
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_EGRESO,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(Egreso0))
